import { useRequest } from 'ahooks'
import { toNumber } from 'lodash'

import { forceCloseAuctionApi } from '@eastcoal/api/trade/auctionOperation/forceCloseAuction'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { AuctionOperationPageStatus } from '../../../enums/AuctionOperationPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { AuctionCloseButtonProps } from './interface'

export const AuctionCloseButton = ({
  record: { id, status }
}: AuctionCloseButtonProps) => {
  const { message } = useFeedback()
  const { tableRef } = useAuctionListStore(state => pick(state, ['tableRef']))
  const { refreshAsync } = useRequest(
    () =>
      forceCloseAuctionApi({
        id
      }),
    {
      manual: true,
      onSuccess() {
        message.success('强制结束成功')
        tableRef.current?.reload()
      }
    }
  )

  const canEnd = [
    AuctionOperationPageStatus.WAIT_START,
    AuctionOperationPageStatus.ENTRUST_CONFIRMED,
    AuctionOperationPageStatus.END,
    AuctionOperationPageStatus.ENTRUST_HALT,
    AuctionOperationPageStatus.HALT_FAIL
  ].includes(toNumber(status))

  return canEnd ? (
    <ConfirmButton danger message='确定强制结束吗？' onConfirm={refreshAsync}>
      强制结束
    </ConfirmButton>
  ) : null
}
